<div>
  <label
    [attr.for]="field().key"
    class="mb-0 d-block fw-bold widget-label"
  >
    {{ field().settings?.label }}
    @if (field().settings?.required) {
      <span class="text-primary ms-1">*</span>
    }
  </label>

  <div class="mt-2 star-container">
    @for (star of stars(); track $index) {
      <button
        class="btn-unstyled me-3"
        (click)="onStarClick(star)"
        (mouseenter)="onStarHover(star)"
        (mouseleave)="onStarLeave()"
      >
        <ng-icon
          [name]="isStarActive(star) ? 'matStar' : 'matStarBorder'"
          [class.active]="isStarActive(star)"
          [class.text-gray-300]="!isStarActive(star)"
          class="pointer-cursor"
        ></ng-icon>
      </button>
    }
  </div>
</div>
